import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { ProductService } from '@shared/services/product/product.service';
import { tap } from 'rxjs';
import { EDIT_CART_ACTIONS } from '@usf/ngrx-order';

@Injectable({
  providedIn: 'root',
})
export class ClientEditCartEffects {
  loadProductsForEditCart$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(EDIT_CART_ACTIONS.loadProductsForEditCart),
        tap(action => {
          this.productService.loadProducts(action.productNumbers);
        }),
      ),
    { dispatch: false },
  );

  constructor(
    private actions$: Actions,
    private productService: ProductService,
  ) {}
}
